module.exports = __webpack_public_path__ + "media/3d3faf6215d347ecab939cbeea34fa76.74ceb8d9.webm";